export const SET_SMART_VALUE = 'SET_SMART_VALUE';



// WEBPACK FOOTER //
// ./src/containers/common/smart/constants.js